export const SET_COOKIE_ACCEPTED = 'SET_COOKIE_ACCEPTED'
